import _ from "lodash";
import API from "../../api/whatsapp";

const DEFAULT_INFO = {
    initialized: false,
    status: {
        created: false,
        ready: false,
        dead: false,
        status: {
            STATE: "UNKNOWN",
            LAUNCH_STATE: "NOT_CREATED",
        },
        error: undefined,
        phoneConnected: false,
        batteryLevel: 100,
        purchased: false,
    },
};
export default {
    namespaced: true,
    state: {
        contacts: [],
        total: 0,
        allContacts: [],
        allContactsTotal: 0,
        searchingResultsOfWpContact: {},
        info: DEFAULT_INFO,
        channelInfo: {},
        channelPhoneDetails: {},
        channelContacts: {},
        templates: {},
        wabaActivityLogs: [],
        wabaActivityLogsPagination: {
            total: 0,
            totalPages: 0,
            currentPage: 1,
            limit: 50,
            hasNextPage: false,
            hasPrevPage: false,
        },
        wabaActivityLogsLoading: false,
        /**
         *         "id": "1",
         *         "name": "Softcand com",
         *         "shortName": "Softcand",
         *         "pushname": "Softcand Yazılım Hizmetleri Anonim Şirketi",
         *         "type": "in",
         *         "verifiedName": "Softcand Yazılım Hizmetleri Anonim Şirketi",
         *         "isBusiness": true,
         *         "isSmb": true,
         *         "forcedBusinessUpdateFromServer": true,
         *         "promises": {},
         *         "status": "908502592789@c.us",
         *         "businessProfile": "908502592789@c.us",
         *         "locale": "tr",
         *         "ref": "2@uOFsM7S/uOwh6DAB5ESPuq4quO315Xeuu/XS2FkViumQWkpkK+kg3O3JZ4kuU9vHy31lk7EyVX33Rw==",
         *         "refTTL": 60000,
         *         "platform": "smba",
         *         "me": {
         *             "server": "c.us",
         *             "user": "908502592789",
         *             "_serialized": "908502592789@c.us"
         *         }
         */
        me: null,
    },
    getters: {
        isHealthy: (state) => {
            const s = state.info.status;
            return state.info.initialized && s.ready && !s.dead && s.phoneConnected;
        },
    },
    mutations: {
        setContacts(state, payload) {
            state.contacts = payload.whatsappContacts;
            state.total = payload.whatsappContactsTotal;
        },
        setAllContacts(state, payload) {
            state.allContacts = payload.whatsappContacts;
            state.allContactsTotal = payload.whatsappContactsTotal;
        },
        deleteContact(state, payload) {
            state.allContacts = state.allContacts.filter((x) => x._id !== payload);
            state.contacts = state.contacts.filter((x) => x._id !== payload);
            state.total -= 1;
            state.allContactsTotal -= 1;
        },
        setChannelContacts(state, { channelId, contacts, total }) {
            state.channelContacts[channelId] = {
                ...(state.channelContacts[channelId] || {}),
                contacts,
                total,
            };
        },
        setSearchingResultWPContact(state, payload) {
            state.searchingResultsOfWpContact[Object.keys(payload)[0]] = Object.values(payload)[0];
        },
        setInfo(state, status) {
            const old = Object.keys(status).reduce((acc, cur) => {
                acc[cur] = state.info.status[cur];
                return acc;
            }, {});
            if (!_.isEqual(status, old)) {
                state.info.status = status;
            }
            if (!state.info.initialized) state.info.initialized = true;
        },
        setChannelInfo(state, { channelId, status }) {
            const _DEFAULT_INFO = _.cloneDeep({ ...DEFAULT_INFO, purchased: true });
            const oldInfo = state.channelInfo[channelId] || _DEFAULT_INFO;
            const old = Object.keys(status).reduce((acc, cur) => {
                acc[cur] = oldInfo.status[cur];
                return acc;
            }, {});
            if (!_.isEqual(status, old)) {
                oldInfo.status = status;
            }
            if (!oldInfo.initialized) oldInfo.initialized = true;
            state.channelInfo[channelId] = oldInfo;
            state.channelInfo = _.cloneDeep(state.channelInfo);
        },
        changePurchaseStatus(state, payload) {
            state.info.status.purchased = payload;
        },
        setMe(state, payload) {
            state.me = payload;
        },
        setChannelPhoneDetail(state, { channelId, payload }) {
            state.channelPhoneDetails[channelId] = payload;
        },
        SET_TEMPLATES: (state, { channelId, templates }) => {
            state.templates[channelId] = templates;
        },
        SET_WABA_ACTIVITY_LOGS(state, { activities, pagination }) {
            state.wabaActivityLogs = activities;
            state.wabaActivityLogsPagination = pagination;
        },
        SET_WABA_ACTIVITY_LOGS_LOADING(state, loading) {
            state.wabaActivityLogsLoading = loading;
        },
        CLEAR_WABA_ACTIVITY_LOGS(state) {
            state.wabaActivityLogs = [];
            state.wabaActivityLogsPagination = {
                total: 0,
                totalPages: 0,
                currentPage: 1,
                limit: 50,
                hasNextPage: false,
                hasPrevPage: false,
            };
        },
    },
    actions: {
        getTemplates({ commit }, channelId) {
            return API.BUSINESS.getTemplates(channelId).then((res) => {
                const templates = _.orderBy(res.data, "createdOn", "desc");
                commit("SET_TEMPLATES", { channelId, templates });
                return templates;
            });
        },
        getBroadcastDetails({ commit }, broadcastId) {
            return API.BROADCAST.getBroadcastDetails(broadcastId).then((res) => {
                return res.data;
            });
        },
        deleteTemplate({ commit }, { channelId, templateName }) {
            return API.BUSINESS.deleteTemplate(channelId, templateName);
        },
        getWabaAccountActivityLog({ commit, state }, { channelId, page = 1, limit = 50, append = false }) {
            commit("SET_WABA_ACTIVITY_LOGS_LOADING", true);
            return API.getWabaAccountActivityLog(channelId, { page, limit })
                .then((res) => {
                    const activities = append
                        ? _.uniqBy([...state.wabaActivityLogs, ...res.data], (q) => q._id)
                        : res.data;
                    commit("SET_WABA_ACTIVITY_LOGS", {
                        activities,
                        pagination: res.pagination,
                    });
                    return res;
                })
                .finally(() => {
                    commit("SET_WABA_ACTIVITY_LOGS_LOADING", false);
                });
        },
        clearWabaActivityLogs({ commit }) {
            commit("CLEAR_WABA_ACTIVITY_LOGS");
        },
    },
};
